import {
  AutocompleteItem,
  AutocompleteSelect,
} from '@prismamedia/one-components';
import { FC } from 'react';
import { searchImageSourceCategories } from './getImageSourceCategories.web.graphql';

interface ImageSourceSelectProps {
  value?: AutocompleteItem;
  onChange?: (value?: AutocompleteItem) => void;
  className?: string;
}

export const ImageSourceSelect: FC<ImageSourceSelectProps> = ({
  value,
  onChange,
  className,
}) => {
  const fetchList = (search: string) =>
    searchImageSourceCategories(search).then((imageSources) =>
      imageSources?.reduce(
        (prev, { id, title, sources }) => [
          ...prev,
          { id, label: title, disabled: true },
          ...sources.map((child) => ({
            id: child.id,
            label: child.title,
            level: 1,
          })),
        ],
        [] as AutocompleteItem[],
      ),
    );

  return (
    <AutocompleteSelect
      label="Source de l'image"
      value={value}
      className={className}
      fetchList={fetchList}
      onChange={onChange}
    />
  );
};
